function initWeglot() {
  if (typeof Weglot === "undefined") {
    setTimeout(initWeglot, 100);
    return;
  }
  // If user has a preferred language set, switch weglot to that
  if (typeof gon !== "undefined" && gon.preferred_language && gon.preferred_language != Weglot.getCurrentLang()) {
    Weglot.switchTo(gon.preferred_language);
  }

  Weglot.on("languageChanged", function (newLang, prevLang) {
    // Dispatch event to update content translation controller
    document.dispatchEvent(new Event("languageChanged"));

    const updateDirection = () => {
      const rtlLangs = ['ar', 'he', 'fa', 'ur'];
      document.documentElement.dir = rtlLangs.includes(newLang) ? 'rtl' : 'ltr';
    };
    updateDirection();

    // Bug on production caused infinite reload loop without this
    // Only return on init if we don't have a user preference to check against
    if (prevLang == "" && (typeof gon === "undefined" || !gon.preferred_language)) { return }

    // If the language is already what the server expects, do nothing
    // This prevents infinite loops where server says 'fr', Weglot loads 'en', we switch to 'fr', and then reload
    if (typeof gon !== "undefined" && gon.preferred_language && gon.preferred_language === newLang) {
      return;
    }

    if (!window.Rails) { return; }

    const reloadPage = () => {
      setTimeout(() => { location.reload(); }, 100);
    }

    const formData = new FormData();

    if (typeof gon !== "undefined" && gon.user_id) {
      formData.append("user[preferred_language]", newLang);
      window.Rails.ajax({
        type: "PUT",
        url: `/users`,
        data: formData,
        success: reloadPage,
        error: reloadPage
      });
    } else {
      formData.append("locale", newLang);
      window.Rails.ajax({
        type: "POST",
        url: `/set_locale_from_weglot`,
        data: formData,
        success: reloadPage,
        error: reloadPage
      });
    }
  });
}

// Start checking for Weglot
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initWeglot);
} else {
  initWeglot();
}
